<div *ngIf="!isHidden">
    <div class="well well-sm">
        <obpa-query-selector 
            [(selection)]="selectedQuery" 
            (selectionChange)="onSelectedQueryChange($event)">
        </obpa-query-selector>
    </div>
    
    <obpa-status
        [status]="status"
        error="{{'ERROR: KEYWORDS'|translate}}"
        (retry)="onRetry()">
    
        <obpa-search-form *ngIf="searchFormModel"
            [searchFormModel]="searchFormModel"
            (search)="performManualSearch($event.value)">
        </obpa-search-form>
    
    </obpa-status>
</div>